import * as d3 from "d3";
import store from '../../../store/index'


export default {
    initState(data, showCumulativeRevenue) {
        let linesState = {};

        Object.keys(data).forEach((dataKey)=>{
            linesState[dataKey] = null;
        });

        if(showCumulativeRevenue){
            linesState['cumulative'] = null;
        }

        return linesState;
    },

    handleLinesStateUpdate(self){
        // handle dim lines
        Object.keys(self.linesState).forEach((key)=>{
            const lineState = self.linesState[key];
            if(lineState !== 'dim') return;
            // dim line
            self.lines.select(`.line-${key}`)
                .classed('dim', true);

            // dim legend
            d3.select(`#view-chart-${self.chartId}`)
                .selectAll(`.legend-item-${key}`)
                .classed('dim', true);
        });

        // handle isolated line
        const isolatedLineKey = Object.keys(self.linesState)
            .find((key)=>self.linesState[key] === 'isolate' );
        
        if(isolatedLineKey === undefined ||  self.data[isolatedLineKey] === undefined) return;

        // isolate line
        self.lines.classed('has-isolate', true);
        self.lines.select(`.line-${isolatedLineKey}`)
            .classed('isolate', true)
            .classed('dim', false);
        self.activeLine = isolatedLineKey;

        // show chart-view-buttons
        if(isolatedLineKey !== 'cumulative'){
            let entity = "drug_brand_name";
            let entityName = "brand_name";

            if(self.filters.chartType == 'growth'){
                entity = "growth";
                entityName = "name";
            }

            d3.select(`#${self.selector}-wrapper`)
                .select('.chart-view-buttons')
                .classed('visible', true)
                .selectAll('button')
                .attr('data-id', isolatedLineKey)
                .attr('data-name', self.data[isolatedLineKey][0][entity][entityName]);
        }

        // isolate legend
        d3.select(`#view-chart-${self.chartId}`)
            .select('.legend-items')
            .classed('has-isolate', true);
        
        d3.select(`#view-chart-${self.chartId}`)
            .selectAll(`.legend-item-${self.activeLine}`)
            .classed('isolate', true);
        
        d3.select(`#view-chart-${self.chartId}`)
            .selectAll(`.legend-item-${self.activeLine}`)
            .select(function getParentNode() { return this.parentNode; })
            .select(`.legend-item-company-name`)
            .classed('isolate', true);
    },

    lineClickEvent(self, id, entity, entityName) {
        // click outside a line and there is an isolated line
        if(!id && self.activeLine){
            // remove isolate
            self.linesState[self.activeLine] = null;
            store.commit('chart/updateLineState',{lineId: self.activeLine, lineState: null});

            self.lines.classed('has-isolate', false)
                .select(`.line-${self.activeLine}`).classed('isolate', false);

            d3.select(`#${self.selector}-wrapper`)
                .select('.chart-view-buttons')
                .classed('visible', false);

            // remove isolate
            d3.select(`#view-chart-${self.chartId}`)
                .select('.legend-items')
                .classed('has-isolate', false);
            
            d3.select(`#view-chart-${self.chartId}`)
                .selectAll(`.legend-item-${self.activeLine}`)
                .classed('isolate', false);
            
            d3.select(`#view-chart-${self.chartId}`)
                .selectAll(`.legend-item-${self.activeLine}`)
                .select(function getParentNode() { return this.parentNode; })
                .select(`.legend-item-company-name`)
                .classed('isolate', false);
                
            self.activeLine = null;
            return;
        }

        if(!id) return;

        // click on another line and there is an isolated line
        if(id && self.activeLine && id != self.activeLine){
            // remove isolate from the isolated line
            this.lineClickEvent(self,null);
        }


        let currentLineSate = self.linesState[id];
        let nextLineSate;
        switch (currentLineSate) {
            case 'isolate':
                nextLineSate= 'dim';
                break;
            case 'dim':
                nextLineSate= null;
                break;
            // currentLineSate == null
            default:
                nextLineSate= 'isolate';
                break;
        }

        switch (nextLineSate) {
            case 'isolate':
                // isolate line
                self.lines.classed('has-isolate', true);
                self.lines.select(`.line-${id}`)
                    .classed('isolate', true)
                    .classed('dim', false);
                self.activeLine = id;

                // show chart-view-buttons
                if(id !== 'cumulative'){
                    d3.select(`#${self.selector}-wrapper`)
                        .select('.chart-view-buttons')
                        .classed('visible', true)
                        .selectAll('button')
                        .attr('data-id', id)
                        .attr('data-name', self.data[id][0][entity][entityName]);
                }

                // isolate legend
                d3.select(`#view-chart-${self.chartId}`)
                    .select('.legend-items')
                    .classed('has-isolate', true);
                
                d3.select(`#view-chart-${self.chartId}`)
                    .selectAll(`.legend-item-${self.activeLine}`)
                    .classed('isolate', true);
                
                d3.select(`#view-chart-${self.chartId}`)
                    .selectAll(`.legend-item-${self.activeLine}`)
                    .select(function getParentNode() { return this.parentNode; })
                    .select(`.legend-item-company-name`)
                    .classed('isolate', true);

                break;

            case 'dim':
                // remove isolate from line & dim line
                self.lines.classed('has-isolate', false);
                self.lines.select(`.line-${id}`)
                    .classed('isolate', false)
                    .classed('dim', true);
                
                // hide chart button
                d3.select(`#${self.selector}-wrapper`)
                    .select('.chart-view-buttons')
                    .classed('visible', false);

                // remove isolate from legend
                d3.select(`#view-chart-${self.chartId}`)
                    .select('.legend-items')
                    .classed('has-isolate', false);
                
                d3.select(`#view-chart-${self.chartId}`)
                    .selectAll(`.legend-item-${self.activeLine}`)
                    .classed('isolate', false);

                d3.select(`#view-chart-${self.chartId}`)
                    .selectAll(`.legend-item-${self.activeLine}`)
                    .select(function getParentNode() { return this.parentNode; })
                    .select(`.legend-item-company-name`)
                    .classed('isolate', false);

                // dim legend
                d3.select(`#view-chart-${self.chartId}`)
                    .selectAll(`.legend-item-${self.activeLine}`)
                    .classed('dim', true);

                self.activeLine = null;
                break;
            // nextLineSate == null
            default:
                // remove dim line
                self.lines.select(`.line-${id}`)
                    .classed('dim', false);

                // remove dim legend
                d3.select(`#view-chart-${self.chartId}`)
                    .selectAll(`.legend-item-${id}`)
                    .classed('dim', false);

                break;
        }

        self.linesState[id] = nextLineSate;
        store.commit('chart/updateLineState', { lineId: id, lineState: nextLineSate });
    },

};